import { Directive, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer2 } from '@angular/core'
import { GridElement, ViewportGridConfig } from 'src/app/merchandise/block-editor/block-editor.service'

@Directive({
    selector: '[element]',
    standalone: true,
})
export class ElementSizeDirective implements OnChanges, OnInit {
	@Input() change: number
	@Input() element: GridElement
	@Input() viewportConfig: ViewportGridConfig
	constructor(private el: ElementRef, private renderer: Renderer2) {}

	ngOnInit(): void {
		this.applyStyles()
	}

	ngOnChanges() {
		this.applyStyles()
	}

	@HostListener('window:resize')
	private applyStyles() {
		if (this.viewportConfig && this.element) {
			this.element = Object.assign(new GridElement(), this.element)

			const size = this.element.findSize(this.viewportConfig.index)
			// get the current breakpoints size
			// figure out where the bottom and right bounds of the element should be
			let gridColumnEndValue = size?.colSpan ? 'span ' + size.colSpan : null
			let gridRowEndValue = size?.rowSpan ? 'span ' + size.rowSpan : null
			// if there is no index
			size?.index !== undefined
				? // or do this which calculates uses its end posotion in the row
				  this.renderer.setStyle(
						this.el.nativeElement,
						'gridRow',
						Math.ceil((size?.index + 1) / this.viewportConfig.columns) + ' / ' + gridRowEndValue,
				  )
				: // then do this which just tacks it on as pos 1
				  this.renderer.setStyle(this.el.nativeElement, 'gridRowEnd', gridRowEndValue)
			size?.index !== undefined
				? // or do this which calculates uses its end posotion in the col
				  this.renderer.setStyle(
						this.el.nativeElement,
						'gridColumn',
						(size?.index % this.viewportConfig.columns) + 1 + ' / ' + gridColumnEndValue,
				  )
				: // then do this which just tacks it on as pos 1
				  this.renderer.setStyle(this.el.nativeElement, 'gridColumnEnd', gridRowEndValue)
		}
	}
}
